// Custom cable request form — photo upload + submit gating. Loaded by sections/cb-custom-cable-request.liquid
(function () {
    var CFG = window.CC_CABLE_FORM || {};
    var FORM_ID = CFG.formId || 'CustomCableForm';
    var UPLOAD_URL = (CFG.uploadUrl || 'https://ag-help-widget.jordanzhoit.workers.dev').replace(/\/+$/, '') + '/upload';
    var MAX_PHOTOS = 6, MAX_EDGE = 1600, JPEG_Q = 0.85;

    if (/[?&]contact_posted=true/.test(location.search) || location.hash === '#' + FORM_ID) {
      var s = document.querySelector('.cc__success');
      if (s) setTimeout(function () { s.scrollIntoView({ block: 'center' }); }, 50);
    }

    var form = document.getElementById(FORM_ID);
    var box = document.getElementById(FORM_ID + '-photobox');
    var input = document.getElementById(FORM_ID + '-photo-input');
    var thumbs = document.getElementById(FORM_ID + '-thumbs');
    var status = document.getElementById(FORM_ID + '-photo-status');
    var urlsField = document.getElementById(FORM_ID + '-photo-urls');
    if (!form || !box) return;
    var btn = form.querySelector('button[type="submit"]');
    var btnLabel = btn.textContent;

    // Each photo: { file, url (preview), remote (uploaded URL), state: 'uploading'|'done'|'error' }
    // Photos upload as soon as they're added, so the hidden Photos field is already
    // filled when the form posts (Shopify's spam check submits the form itself).
    var photos = [];
    var wantSubmit = false;

    function say(msg, isErr) { status.textContent = msg || ''; status.classList.toggle('is-error', !!isErr); }
    function uploading() { return photos.some(function (p) { return p.state === 'uploading'; }); }

    function syncField() {
      urlsField.value = photos.filter(function (p) { return p.remote; }).map(function (p) { return p.remote; }).join('\n');
    }

    function syncButton() {
      if (uploading()) {
        btn.type = 'button';
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = wantSubmit ? 'Finishing photo upload, then sending…' : 'Uploading photos…';
      } else {
        btn.type = 'submit';
        btn.removeAttribute('aria-busy');
        btn.textContent = btnLabel;
        if (wantSubmit) { wantSubmit = false; btn.click(); }
      }
    }

    function render() {
      thumbs.innerHTML = '';
      photos.forEach(function (p, i) {
        var d = document.createElement('div'); d.className = 'cc__thumb';
        if (p.state === 'uploading') d.style.opacity = '0.55';
        var img = document.createElement('img'); img.src = p.url; img.alt = 'Photo ' + (i + 1);
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Remove photo ' + (i + 1)); b.innerHTML = '&times;';
        b.addEventListener('click', function () { URL.revokeObjectURL(p.url); photos.splice(photos.indexOf(p), 1); syncField(); render(); syncButton(); });
        d.appendChild(img); d.appendChild(b); thumbs.appendChild(d);
      });
      var n = photos.length, up = photos.filter(function (p) { return p.state === 'uploading'; }).length;
      if (status.classList.contains('is-error') && !up) return;
      if (!n) say('');
      else if (up) say('Uploading ' + up + ' of ' + n + ' photo' + (n > 1 ? 's' : '') + '…');
      else say(n + ' photo' + (n > 1 ? 's' : '') + ' attached.');
    }

    // Shrink in the browser so uploads are quick on farm cell signal.
    function shrink(file) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        var u = URL.createObjectURL(file);
        img.onload = function () {
          URL.revokeObjectURL(u);
          var w = img.naturalWidth, h = img.naturalHeight, scale = Math.min(1, MAX_EDGE / Math.max(w, h));
          var c = document.createElement('canvas'); c.width = Math.round(w * scale); c.height = Math.round(h * scale);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          resolve({ media_type: 'image/jpeg', data: c.toDataURL('image/jpeg', JPEG_Q).split(',')[1] });
        };
        img.onerror = function () { URL.revokeObjectURL(u); reject(new Error('Could not read ' + file.name)); };
        img.src = u;
      });
    }

    function upload(p) {
      var ref = (form.querySelector('[name="contact[Name]"]').value || '').trim();
      return shrink(p.file)
        .then(function (image) {
          return fetch(UPLOAD_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ref: ref, images: [image] }) });
        })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || !j.urls || !j.urls[0]) throw new Error(j.error || 'Upload failed'); return j.urls[0]; }); })
        .then(function (url) { p.remote = url; p.state = 'done'; })
        .catch(function (err) {
          p.state = 'error';
          photos.splice(photos.indexOf(p), 1);
          say('One photo didn’t upload (' + (err && err.message ? err.message : 'network error') + '). Try adding it again, or email it to sales@spraycenter.com after you send this.', true);
        })
        .then(function () { syncField(); render(); syncButton(); });
    }

    function addFiles(list) {
      var files = Array.prototype.slice.call(list || []).filter(function (f) { return f && /^image\//.test(f.type); });
      if (!files.length) return;
      if (photos.length + files.length > MAX_PHOTOS) { say('Up to ' + MAX_PHOTOS + ' photos, please.', true); files = files.slice(0, MAX_PHOTOS - photos.length); }
      files.forEach(function (f) {
        var p = { file: f, url: URL.createObjectURL(f), remote: null, state: 'uploading' };
        photos.push(p);
        upload(p);
      });
      render(); syncButton();
    }

    input.addEventListener('change', function () { addFiles(input.files); input.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) { box.addEventListener(ev, function (e) { e.preventDefault(); box.classList.add('is-drag'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { box.addEventListener(ev, function (e) { e.preventDefault(); box.classList.remove('is-drag'); }); });
    box.addEventListener('drop', function (e) { addFiles(e.dataTransfer && e.dataTransfer.files); });
    form.addEventListener('paste', function (e) {
      var items = e.clipboardData && e.clipboardData.items; if (!items) return;
      var files = [];
      for (var i = 0; i < items.length; i++) if (items[i].kind === 'file') { var f = items[i].getAsFile(); if (f) files.push(f); }
      if (files.length) { e.preventDefault(); addFiles(files); }
    });

    // Clicked Send while a photo is still uploading: remember, and send when it lands.
    btn.addEventListener('click', function () {
      if (btn.type === 'button') { wantSubmit = true; syncButton(); }
    });

    form.addEventListener('submit', function () {
      syncField();
      try { window.Shopify && Shopify.analytics && Shopify.analytics.publish('custom_cable_request', { photos: photos.length }); } catch (err) {}
    });
  })();
